import { Component, Injector, inject } from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import { ROUTES } from '../../app-routes.constant';
import {Router} from '@angular/router';


@Component({
    selector: 'dd-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
  public pathSelected = 'login';
  public errorMsg;
  public signUp: any = {
    reviewer: {
      title: 'Reviewer or Review Leader',
      link: ROUTES.REVIEWER_REGISTRATION
    },
    agencyUser: {
      title: 'External Agency or Graphics Partner',
      link: ROUTES.USER_REGISTRATION
    }
  }
  emailFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);
  passwordFormControl = new UntypedFormControl('', [
    Validators.required
  ]);
  public router = inject(Router);
  public injector = inject(Injector);
  
  navigateMenu(tag: string) {
    if (tag === 'reviewer' || tag === 'agencyUser') {
      this.router.navigate([this.signUp.reviewer.link]);
    }
    if (tag === 'login') {
      if (this.emailFormControl.valid &&
        this.passwordFormControl.valid) {
        localStorage.setItem('token', new Date().toString());
        this.router.navigate(['/home']);
      }else{
        this.errorMsg = 'Invalid Login';
      }
    }
  }
}
